function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.75 10.75H10c-1.52 0-2.75-1.23-2.75-2.75S8.48 5.25 10 5.25h2.75v5.5zm-2.75-4a1.25 1.25 0 000 2.5h1.25v-2.5H10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.75 14.75H10c-1.52 0-2.75-1.23-2.75-2.75S8.48 9.25 10 9.25h2.75v5.5zm-2.75-4a1.25 1.25 0 000 2.5h1.25v-2.5H10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 18.75c-1.52 0-2.75-1.23-2.75-2.75s1.23-2.75 2.75-2.75h2.75V16c0 1.52-1.23 2.75-2.75 2.75zm0-4A1.25 1.25 0 1011.25 16v-1.25H10zm4-4h-2.75v-5.5H14c1.52 0 2.75 1.23 2.75 2.75s-1.23 2.75-2.75 2.75zm-1.25-1.5H14a1.25 1.25 0 000-2.5h-1.25v2.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 14.75c-1.52 0-2.75-1.23-2.75-2.75S12.48 9.25 14 9.25s2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75zm0-4a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
})));